import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { CalendarCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-hierarchy-list.response';
import { CultivationPeriodType } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/cultivation-period-type.enum';
import moment from 'moment';
import { CalendarPeriodLineComponent } from './calendar-period-line/calendar-period-line.component';
import { CultivationItemViewerComponent } from '../../../../../garden/@components/hierarchy-item/cultivation-item-viewer/cultivation-item-viewer.component';
import { ChevronRightIconComponent } from '../../../../../@icons/chevron-right.component';
import { CommonModule } from '@angular/common';
import { MyCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/my-cultivation-list.response';

@Component({
    selector: 'vw-calendar-hierarchy-card-item',
    imports: [CalendarPeriodLineComponent, CultivationItemViewerComponent, ChevronRightIconComponent, CommonModule],
    templateUrl: './calendar-hierarchy-card-item.component.html',
    styleUrl: './calendar-hierarchy-card-item.component.scss'
})
export class CalendarHierarchyCardItemComponent implements OnInit {
  @Input() cultivation!:
    | MyCultivationListResponse
    | CalendarCultivationListResponse;
  @Input() name: string;
  @Input() type: 'cultivation' | 'hierarchy';
  @Input() periods: { startDate: Date, endDate: Date, type: CultivationPeriodType }[];
  @Input() isOpen: boolean;
  @Output() clickItem: EventEmitter<void> = new EventEmitter();
  @Input() showSeed: boolean = true;
  @Input() showHarvest: boolean = true;

  seedPeriods: { startMonth: number, endMonth: number }[] = [];
  harvestPeriods: { startMonth: number, endMonth: number }[] = [];

  ngOnInit() {
    const mappedPeriods = this.periods.map(period => ({
      startMonth: moment(period.startDate).month() + 1,
      endMonth: moment(period.endDate).month() + 1,
      type: period.type
    }));

    this.seedPeriods = mappedPeriods.filter(period => period.type === CultivationPeriodType.SEEDLING);
    this.harvestPeriods = mappedPeriods.filter(period => period.type === CultivationPeriodType.HARVEST);
  }

  onClick() {
    this.clickItem.emit();
  }
}
